<script lang="ts">
    import cn from 'classnames';

    import { oauth } from '@api/user';
    import LL from '@i18n/i18n-svelte';
    import { Cookie } from '@shared/cookies';
    import { AuthMethod, UserGender } from '@shared/types/user';
    import { Button, ButtonTypes } from '@uikit/button';
    import { getCookie } from '@utils/cookies';

    import s from './google-button.module.css';

    export let signup = false;
    export let gender: UserGender | undefined = undefined;

    function onClick() {
        const cookiesAllowedAt = getCookie(Cookie.CookiesAllowedAt);
        oauth(AuthMethod.Google, gender, cookiesAllowedAt);
    }
</script>

<Button
    type={ButtonTypes.Type.Button}
    fullWidth
    attrs={{ 'data-testid': `${signup ? 'googleSignup' : 'googleSignin'}` }}
    on:click={onClick}
>
    <img class={cn(s.mr)} src="/icons/google.svg" alt="google" />
    {signup ? $LL.auth.signupGoogle() : $LL.auth.signinGoogle()}
</Button>
